// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"e5e40987","732":"d15baa24","977":"08a04d64"}[chunkId] + ".chunk.js";
};